<template>
    <info-screen
            class="startRegistration"
            :title="$ml.get('startRegTitle')"
            :text="$ml.get('startRegText')"
            :action="nextScreen"
            :buttonText="$ml.get('startRegButtonNext')"
            :titleH1="false"
    >
        <!--<template slot="middle">-->
            <!--<div class="bankId link">-->
                <!--<svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                    <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M3.04327 5.84819C3.49934 3.78884 3.74933 1.85354 3.86217 0.833333H10.0427C10.2203 2.69324 10.8838 7.65064 13.1857 11.9063C10.9164 15.93 10.2296 21.2404 10.0448 23.1667H3.89732C3.82713 22.1487 3.64968 20.2681 3.21641 18.2147C2.77027 16.1003 2.03614 13.7187 0.809435 11.9145C1.87026 10.3068 2.57619 7.95731 3.04327 5.84819ZM3.08717 0.606364C3.1241 0.262628 3.40001 0 3.72983 0H10.1701C10.5088 0 10.7901 0.277224 10.8222 0.630872C10.9797 2.36417 11.6136 7.3501 13.912 11.5599C14.0321 11.7798 14.0288 12.0509 13.9049 12.2683C11.6504 16.2215 10.989 21.5719 10.8236 23.3765C10.7913 23.7282 10.5115 24 10.1746 24H3.76331C3.41981 24 3.13687 23.7181 3.11363 23.3587C2.98988 21.4452 2.43551 15.7019 0.135031 12.3582C-0.0452807 12.0961 -0.0440205 11.7398 0.132874 11.4752C2.09755 8.53607 2.88056 2.52915 3.08717 0.606364ZM4.57705 22.1667L9.34451 2.5C9.52991 4.30556 10.8542 10.25 12.1255 11.9167C10.5364 15 9.66234 19.3333 9.34451 22.1667H4.57705Z" fill="#5CD69B"/>-->
                <!--</svg>-->
                <!--<p v-text="$ml.get('startRegCheckBankId')"></p>-->
            <!--</div>-->
        <!--</template>-->
        <template slot="bottomLink">
            <a class="link" @click.stop="cancelReg" v-text="$ml.get('startRegLater')">Зареєструватись пізніше</a>
            <p class="linkText" v-text="$ml.get('startRegLaterText')">Ви не зможете отримати або відправити посилку</p>
        </template>
    </info-screen>

</template>

<script>
    import InfoScreen from "../../components/layout/info-screen";
    export default {
        name: "startRegistration",
        components: {InfoScreen},
        methods: {
            nextScreen: function () {
                this.$router.push({ name: 'RegistrationLastName'});
            },
            cancelReg: function () {
                this.$router.push({ name: 'RegistrationCancel'});
            }
        }
    }
</script>

<style lang="scss" scoped>

    .link {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        display: block;
        margin-bottom: 20px;
    }
    .linkText {
        font-weight: 300;
        font-size: 12px;
        line-height: 15px;
        margin-bottom: 24px;
        margin-top: -12px;
    }
    .bankId {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 12px;
        p {
            font-weight: 500;
        }
        svg { margin-right: 12px;}
    }
    @media (min-width: 601px) and (max-width: 750px) {
        .bankId { margin-bottom: 16px;}
    }
    @media (min-width: 751px) {
        .bankId { margin-bottom: 16px;}
    }
</style>